<mec-campus-survey
  [surveyModel]="surveyModel"
  (completeSurvey)="completeSurvey($event.questions)"
  [hideCloseButton]="true"
></mec-campus-survey>
